import { render } from "./relatedPartsTable.vue?vue&type=template&id=9820eef4&ts=true"
import script from "./relatedPartsTable.ts?vue&type=script&lang=ts"
export * from "./relatedPartsTable.ts?vue&type=script&lang=ts"

import "./relatedPartsTable.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__